import React from "react";
import DatePicker from "react-datepicker";
import { Controller, RegisterOptions, useFormContext, ValidationValueMessage } from "react-hook-form";
import moment from "moment";
import { ErrorMessage } from "@hookform/error-message";

type DateInputProps = {
    name: string,
    className: string,
    label: string,
    placeholderText: string,
    selected: Date | null,
    minDate: Date,
    fieldOptions?: RegisterOptions,
    onChange?: (date: Date) => void
}

const DateInput = (props: DateInputProps) => {
    const { register, getValues, setValue, control, formState: { errors }, setError, clearErrors, trigger } = useFormContext();
    const { name, className, label, placeholderText, minDate, fieldOptions } = props;

    const valueDateFormat = "YYYY-MM-DD";
    const displayDateFormat = "dd/MM/yyyy"

    let hasValue = !!getValues(name);

    const setDate = async (date: Date) => {
        let value = null;

        const _setError = () => {
            const req = fieldOptions?.required as ValidationValueMessage<boolean>;
            setError(name, { type: "custom", message: req.message });
        }

        try {
            if (date != null) {
                value = new Date(moment(date).format(valueDateFormat));
                hasValue = true;
                clearErrors(name);
            } else {
                _setError();
            }
        } catch (error) {
            value = null;
            hasValue = false;
            _setError();
        }

        setValue(name, value);

        if (props.onChange) {
            props.onChange(date);
        }

        await trigger(name);
    }

    return (
        <>
            <Controller
                name={name}
                control={control}
                render={({
                    field: { value, name }
                }) => (
                    <DatePicker
                        className={className}
                        placeholderText={placeholderText}
                        autoComplete="off"
                        selected={value}
                        dateFormat={displayDateFormat}
                        minDate={minDate}
                        {...register(name, fieldOptions)}
                        onChange={setDate} />
                )}
            />

            {hasValue && <label className="datepicker-label">{label}</label>}

            <ErrorMessage
                errors={errors}
                name={name}
                render={({ message }) => <p className="error">{message}</p>}
            />
        </>
    );

}

export default DateInput;
